import Login from '@/views/authentication/Login.vue'
import SignUp from '@/views/authentication/SignUp.vue'
import ResetPassword from '@/views/authentication/ResetPassword.vue'
import RecoverPassword from '@/views/authentication/RecoverPassword.vue'

const authentication = [
    {
        path: '/login',
        name: 'Login',
        component: Login,
        children: [],
        meta: {
            requiresAuth: false
        },
    },
    {
        path: '/sign-up',
        name: 'SignUp',
        component: SignUp,
        children: [],
        meta: {
            requiresAuth: false
        },
    },
    {
        path: '/reset-password/:token',
        name: 'ResetPassword',
        component: ResetPassword,
        children: [],
        meta: {
            requiresAuth: false
        },
        props: (route) => ({ token: route.params.token }),
    },
    {
        path: '/recover-password',
        name: 'RecoverPassword',
        component: RecoverPassword,
        children: [],
        meta: {
            requiresAuth: false
        },
    },
]

export default authentication
